import React from "react";
import classnames from "classnames";
import leaf from "./images/leaf.png";
import "./card.css";

const Card = ({ onClick, card, index, isInactive, isFlipped, isDisabled }) => {
  const handleClick = () => {
    !isFlipped && !isDisabled && onClick(index);
  };

  return (
    <div
      className={classnames("card", {
        "is-flipped": isFlipped,
        "is-inactive": isInactive
      })}
      onClick={handleClick}
    >
      <div className="card-face card-font-face">
        <img src={leaf} alt="img" />
      </div>
      <div className="card-face card-back-face">
        <img src={card.image} alt="img" />
      </div>
    </div>
  );
};

export default Card;
